<div class="min-h-full bg-[#f8f9fa] dark:bg-slate-900 p-4 md:p-8   overflow-x-hidden">

    <!-- Header Section -->
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
        <div>
            <h1 class="text-2xl font-bold text-gray-800 dark:text-slate-100 tracking-tight">รายการ QR Code EV</h1>
            <p class="text-gray-500 dark:text-slate-400 text-sm mt-1">ประวัติการสร้าง QR Code สำหรับหัวชาร์จ</p>
        </div>
        <div class="flex items-center gap-3">
        </div>
    </div>

    <!-- Bottom Section: Data Table -->
    <div
        class="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700 overflow-hidden">

        <!-- Table Header & Controls -->
        <div
            class="p-6 border-b border-gray-100 dark:border-slate-700 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <h3 class="text-lg font-bold text-gray-800 dark:text-slate-100">ประวัติการสร้าง QR</h3>

            <div class="flex items-center gap-3">
                <!-- Search -->
                <div class="relative">
                    <span
                        class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-gray-400 text-lg">search</span>
                    <input type="text" placeholder="ค้นหา..." [(ngModel)]="searchText"
                        (ngModelChange)="onSearch($event)"
                        class="pl-9 pr-4 py-2 border border-gray-200 dark:border-slate-600 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-yellow-400 dark:text-slate-200 focus:border-transparent w-full md:w-64 bg-gray-50 dark:bg-slate-900 focus:bg-white dark:focus:bg-slate-800 transition-all">
                </div>

                <button (click)="onRefresh()"
                    class="p-2 border border-gray-200 dark:border-slate-600 rounded-xl hover:bg-gray-50 dark:hover:bg-slate-700 text-gray-500 dark:text-slate-400 transition-colors"
                    title="รีเฟรช">
                    <span class="material-icons text-lg">refresh</span>
                </button>
            </div>
        </div>

        <!-- Table -->
        <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
                <thead>
                    <tr class="bg-gray-50/50 dark:bg-slate-800/50 border-b border-gray-100 dark:border-slate-700">
                        <th (click)="sortData('id')"
                            class="p-4 text-xs font-bold text-gray-500 dark:text-slate-400 uppercase tracking-wider cursor-pointer hover:text-gray-700 dark:hover:text-slate-200 transition-colors">
                            <div class="flex items-center gap-1">ID <span class="material-icons text-[10px]"
                                    *ngIf="sortColumn === 'id'">{{sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward'}}</span></div>
                        </th>
                        <th (click)="sortData('siteEvName')"
                            class="p-4 text-xs font-bold text-gray-500 dark:text-slate-400 uppercase tracking-wider cursor-pointer hover:text-gray-700 dark:hover:text-slate-200 transition-colors">
                            <div class="flex items-center gap-1">ชื่อหัวชาร์จ <span class="material-icons text-[10px]"
                                    *ngIf="sortColumn === 'siteEvName'">{{sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward'}}</span></div>
                        </th>
                        <th (click)="sortData('spaceName')"
                            class="p-4 text-xs font-bold text-gray-500 dark:text-slate-400 uppercase tracking-wider cursor-pointer hover:text-gray-700 dark:hover:text-slate-200 transition-colors">
                            <div class="flex items-center gap-1">ช่องจอด <span class="material-icons text-[10px]"
                                    *ngIf="sortColumn === 'spaceName'">{{sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward'}}</span></div>
                        </th>
                        <th class="p-4 text-xs font-bold text-gray-500 dark:text-slate-400 uppercase tracking-wider">
                            ลิงก์ QR</th>
                        <th (click)="sortData('created_at')"
                            class="p-4 text-xs font-bold text-gray-500 dark:text-slate-400 uppercase tracking-wider text-right cursor-pointer hover:text-gray-700 dark:hover:text-slate-200 transition-colors">
                            <div class="flex items-center justify-end gap-1">วันที่สร้าง <span
                                    class="material-icons text-[10px]"
                                    *ngIf="sortColumn === 'created_at'">{{sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward'}}</span></div>
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-50 dark:divide-slate-700/50">
                    <tr *ngFor="let c of filteredAndPaginatedData"
                        class="group hover:bg-blue-50/30 dark:hover:bg-slate-700/50 transition-colors">
                        <td class="p-4 text-sm font-bold text-gray-900 dark:text-slate-200">#{{c.id}}</td>
                        <td class="p-4 text-sm text-gray-600 dark:text-slate-300 font-medium">{{c.siteEvName || '-'}}
                        </td>
                        <td class="p-4 text-sm text-gray-600 dark:text-slate-300">
                            <span
                                class="px-2 py-1 bg-gray-100 dark:bg-slate-700 rounded text-xs font-semibold text-gray-500 dark:text-slate-400 group-hover:bg-white dark:group-hover:bg-slate-800 transition-colors">{{c.spaceName
                                || '-'}}</span>
                        </td>
                        <td class="p-4">
                            <a [href]="c.qrUrl" target="_blank"
                                class="inline-flex items-center gap-1 text-xs font-bold text-blue-500 hover:text-blue-600 bg-blue-50 dark:bg-blue-900/30 dark:hover:bg-blue-900/50 hover:bg-blue-100 px-3 py-1.5 rounded-full transition-all">
                                <span class="material-icons text-[14px]">link</span> เปิดลิงก์
                            </a>
                        </td>
                        <td class="p-4 text-sm text-gray-500 dark:text-slate-400 text-right">{{c.created_at |
                            date:'dd/MM/yyyy HH:mm'}}</td>
                    </tr>
                    <tr *ngIf="filteredAndPaginatedData.length === 0">
                        <td colspan="5" class="p-8 text-center text-gray-400 dark:text-slate-500">
                            <div class="flex flex-col items-center gap-2">
                                <span
                                    class="material-icons text-4xl text-gray-200 dark:text-slate-600">search_off</span>
                                <span>ไม่พบข้อมูล</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div
            class="p-4 border-t border-gray-100 dark:border-slate-700 bg-gray-50/30 dark:bg-slate-800/80 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div class="text-xs text-gray-500 dark:text-slate-400 font-medium">
                แสดง <span class="text-gray-900 dark:text-slate-200">{{(currentPage - 1) * pageSize + 1}}</span> ถึง
                <span class="text-gray-900 dark:text-slate-200">{{currentPage * pageSize > evQrs.length ? evQrs.length :
                    currentPage *
                    pageSize}}</span> จาก <span class="text-gray-900 dark:text-slate-200">{{evQrs.length}}</span> รายการ
            </div>

            <div class="flex items-center gap-2">
                <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
                    class="w-8 h-8 flex items-center justify-center rounded-lg bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-500 dark:text-slate-400 hover:bg-gray-50 dark:hover:bg-slate-700 hover:text-gray-900 dark:hover:text-slate-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm">
                    <span class="material-icons text-sm">chevron_left</span>
                </button>

                <div class="flex gap-1">
                    <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                        class="w-8 h-8 flex items-center justify-center rounded-lg text-xs font-bold transition-all shadow-sm"
                        [ngClass]="page === currentPage ? 'bg-yellow-400 text-white shadow-yellow-200' : 'bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-600 dark:text-slate-400 hover:bg-gray-50 dark:hover:bg-slate-700 hover:text-gray-900 dark:hover:text-slate-200'">
                        {{page}}
                    </button>
                </div>

                <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages"
                    class="w-8 h-8 flex items-center justify-center rounded-lg bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 text-gray-500 dark:text-slate-400 hover:bg-gray-50 dark:hover:bg-slate-700 hover:text-gray-900 dark:hover:text-slate-200 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm">
                    <span class="material-icons text-sm">chevron_right</span>
                </button>
            </div>
        </div>
    </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>